import * as _ from "lodash-es";
import { useContext, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import IOrder from "../../../models/IOrder";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import { StandardCatalogItemLookup } from "../StandardCatalogItemLookup/StandardCatalogItemLookup";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import { IAddBulkItems } from "@models/IAddBulkItems";

type Props = {
    order: IOrder;
    showCustom: boolean;
    getNextItemNoFn: any;
    processStandardItemFn: any;
    addOrderEntryItemFn: ProcessOrderEntryItemFn;
    addBulkItemsFn: (items: IAddBulkItems[]) => void;
    isReadOnly: boolean;
    searchPhrase: string;
    clearScanCodeFn: () => void;
};

export const OrderInputPanel = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

    const inputPanel = () => {
        if (_.isNil(props.order!.catalog_id)) {
            if (!props.showCustom) {
                return null;
            }
        }

        const tabOptions = [
            {
                name: "Catalog",
                panelComponent: (
                    <StandardCatalogItemLookup
                        order={props.order!}
                        addItemFn={props.addOrderEntryItemFn}
                        addItemBulkFn={props.addBulkItemsFn}
                        processStandardItemFn={props.processStandardItemFn}
                        getNextItemNoFn={props.getNextItemNoFn}
                        searchPhrase={props.searchPhrase}
                        clearScanCodeFn={props.clearScanCodeFn}
                    />
                ),
            },
        ];

        const tabs = tabOptions.map((opt, index) => {
            const tabName = <FormattedMessage id={_.lowerCase(opt.name)} defaultMessage={opt.name} description="Tab Item Title" />;

            if (opt.name === "Catalog") {
                if (props.order!.catalog_id) {
                    return <Tab key={index}>{tabName}</Tab>;
                }
            } else if (opt.name === "Files") {
                if (props.order) {
                    return (
                        <Tab key={index}>
                            {tabName}
                            <span
                                style={{ fontSize: "14px" }}
                                className={
                                    "file-attachments " +
                                    (props.order.attachments.length ? "ms-2 faded-orange-bg attachment-circle" : "d-none")
                                }>
                                {props.order.attachments.length}
                            </span>
                        </Tab>
                    );
                }
            } else {
                return <Tab key={index}>{tabName}</Tab>;
            }
        });

        const tabPanels = tabOptions.map((opt, index) => {
            if (opt.name === "Catalog") {
                if (props.order!.catalog_id) {
                    return <TabPanel key={index}>{opt.panelComponent}</TabPanel>;
                }
            } else {
                return <TabPanel key={index}>{opt.panelComponent}</TabPanel>;
            }
        });

        return (
            <Tabs
                defaultIndex={1}
                onSelect={(index, lastIndex, event) => {
                    // console.log("Selected A Tab.");
                }}>
                <TabList>{tabs}</TabList>

                {tabPanels}
            </Tabs>
        );
    };

    let inputPanelComponent: any = null;

    if (!props.isReadOnly) {
        inputPanelComponent = inputPanel();
    }

    // console.log("inputPanel", inputPanel);

    if (!_.isNil(supplierModel) && supplierModel.allow_edit_after_confirm) {
        if (
            isOnline &&
            (props.order!.order_state_id === OrderStatesEnum.SHIPPED || props.order!.order_state_id === OrderStatesEnum.READY_FOR_PICKUP)
        ) {
            // do nothing?
        } else {
            inputPanelComponent = inputPanel();
        }
    }

    return (
        <div className="OrderInputPanel" id={"OrderInputPanel"}>
            {inputPanelComponent}
        </div>
    );
};

export default OrderInputPanel;
